'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_UserProfilePage$Dialog$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.a7n = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_pages_UserProfilePage$Dialog$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "editUser");
  this.a7n = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
}
export { $c_Lmealorama_pages_UserProfilePage$Dialog$ as $c_Lmealorama_pages_UserProfilePage$Dialog$ };
$p = $c_Lmealorama_pages_UserProfilePage$Dialog$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_pages_UserProfilePage$Dialog$;
/** @constructor */
function $h_Lmealorama_pages_UserProfilePage$Dialog$() {
}
export { $h_Lmealorama_pages_UserProfilePage$Dialog$ as $h_Lmealorama_pages_UserProfilePage$Dialog$ };
$h_Lmealorama_pages_UserProfilePage$Dialog$.prototype = $p;
var $d_Lmealorama_pages_UserProfilePage$Dialog$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_UserProfilePage$Dialog$, "mealorama.pages.UserProfilePage$Dialog$", ({
  LD: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_pages_UserProfilePage$Dialog$ as $d_Lmealorama_pages_UserProfilePage$Dialog$ };
var $n_Lmealorama_pages_UserProfilePage$Dialog$;
function $m_Lmealorama_pages_UserProfilePage$Dialog$() {
  if ((!$n_Lmealorama_pages_UserProfilePage$Dialog$)) {
    $n_Lmealorama_pages_UserProfilePage$Dialog$ = new $c_Lmealorama_pages_UserProfilePage$Dialog$();
  }
  return $n_Lmealorama_pages_UserProfilePage$Dialog$;
}
export { $m_Lmealorama_pages_UserProfilePage$Dialog$ as $m_Lmealorama_pages_UserProfilePage$Dialog$ };
//# sourceMappingURL=mealorama.pages.-User-Profile-Page$-Dialog$.js.map
